import Flex from "common/Boxes/Flex";
import Button from "common/Buttons/Button";
import React from "react";
import Modal from "common/Modal/Modal";
import Text from "common/Typography/Text";
import { AutoRenewalModalProps } from "@shared/features/settings/subscription/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const AutoRenewalModal = ({
  isOpen,
  closeModal,
  content,
  footerData,
}: AutoRenewalModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);

  const footer = (
    <Flex $justifyContent="flex-end" style={{ columnGap: 8 }}>
      <Button onClick={footerData.secondaryButton.onClick}>
        {footerData.secondaryButton.text}
      </Button>
      <Button onClick={footerData.primaryButton.onClick} type="primary">
        {footerData.primaryButton.text}
      </Button>
    </Flex>
  );

  return (
    <Modal
      title={t("auto_renewal_modal.title")}
      open={isOpen}
      onCancel={closeModal}
      footer={footer}
      width={520}
    >
      {content.map((string, key) => (
        <Text key={key}>{string}</Text>
      ))}
    </Modal>
  );
};

export default AutoRenewalModal;
